import { FileOutlined } from "@ant-design/icons";
import { Button, DatePicker, Form } from "antd";
import dayjs from 'dayjs'
import { json2csv } from "json-2-csv";
import { useState } from "react";
import axiosInstance from "../common/api";
import { downloadFile, stringToFile } from "../common/common";

export default function () {
    return (
            <Form
                layout="vertical"
                onFinish={(form) =>
                    axiosInstance
                        .get("paysummary", {
                            params: {
                                start: form.date.startOf("month").format("YYYY-MM-DD"),
                                end: form.date.endOf("month").format("YYYY-MM-DD"),
                            },
                        })
                        .then(({ data }) => {
                    const csv = json2csv(data.map((x) => {
                        return {
                            Mese: dayjs(x.month).format("MMMM YYYY"),
                            Matricola: x.employee.payrollId,
                            Dipendente: x.employee.lastName + " " + x.employee.firstName,
                            "Ore totali": x.totalHours,
                            "€/ora": x.hourRate,
                            Totale: x.total,
                        };
                    }),{delimiter:{field: ";"}})
                    stringToFile(csv,`prospetto-ore_${form.date.format("YYYY_MM")}.csv`)
                })
                }
            >
                <Form.Item name={"date"} label="Periodo">
                    <DatePicker.MonthPicker format="MMMM YYYY" />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit" icon={<FileOutlined/>}>
                        Scarica CSV
                    </Button>
                </Form.Item>
            </Form>
    );
}
